function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
  id: "family_svg__b",
  cx: 48,
  cy: 48,
  rx: 48,
  ry: 47.723
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "family_svg__d",
  cx: 48,
  cy: 48,
  rx: 48,
  ry: 47.723
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "family_svg__f",
  cx: 28,
  cy: 28,
  rx: 28,
  ry: 27.838
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.584 2.064L95.44 77.81c1.592 2.751-.4 6.19-3.585 6.19H4.145C.959 84-1.031 80.561.56 77.81L44.415 2.064c1.594-2.752 5.575-2.752 7.17 0",
  id: "family_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.584 2.064L95.44 77.81c1.592 2.751-.4 6.19-3.585 6.19H4.145C.959 84-1.031 80.561.56 77.81L44.415 2.064c1.594-2.752 5.575-2.752 7.17 0",
  id: "family_svg__c"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.09 1.204l25.583 44.185c.93 1.605-.232 3.611-2.091 3.611H2.418C.559 49-.602 46.994.327 45.389L25.909 1.204c.93-1.605 3.252-1.605 4.182 0",
  id: "family_svg__e"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FBAD00",
  xlinkHref: "#family_svg__a",
  transform: "translate(0 96)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FF7D13",
  xlinkHref: "#family_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FBAD00",
  xlinkHref: "#family_svg__c",
  transform: "translate(126 96)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FF7D13",
  xlinkHref: "#family_svg__d",
  transform: "translate(126)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#0AC700",
  xlinkHref: "#family_svg__e",
  transform: "translate(267 131)"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FF7D13",
  xlinkHref: "#family_svg__f",
  transform: "translate(267 75)"
}));

function SvgFamily(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 323 180"
  }, props), _ref, _ref2);
}

export default SvgFamily;